<template>
  <v-container
    id="qr-transaction-list"
    fluid
    tag="section"
  >
    <base-material-card outlined icon="mdi-qrcode" class="overflow-visible qr-transaction__wrapper">
      <template v-slot:after-heading>
        <div class="font-weight-light card-title mt-2">Danh sách giao dịch QR</div>
      </template>
      
      <filter-form :filter-form="filterForm" :filterContactStatusList="[]" @exportExcel="exportExcel" />
      
      <qr-transaction-table
        :transactions="transactions"
        :currentPage="currentPage"
        :limit="limit"
      />
      
      <div class="pb-0 d-flex justify-end px-3 mt-5">
        <div class="text-right mb-1 mt-2">
          {{ showTransactionsIndex() }}
          <v-btn
            small
            class="pagination-btn-left"
            @click="currentPage--; idPaging = paging.previousId"
            :disabled="currentPage == 1"
          >
            <v-icon>mdi-menu-left</v-icon>
          </v-btn>
          <v-btn
            small
            class="pagination-btn-right"
            @click="currentPage++; idPaging = paging.nextId"
            :disabled="!paging.nextId"
          >
            <v-icon>mdi-menu-right</v-icon>
          </v-btn>
        </div>
      </div>
    </base-material-card>
  </v-container>
</template>

<script>
import FilterForm from './components/FilterForm.vue'
import QrTransactionTable from './components/QrTransactionTable.vue'
import PaymentQRCodeRepository from '@/repositories/PaymentQRCodeRepository'

export default {
  name: 'QrTransactionList',
  components: { 
    FilterForm, 
    QrTransactionTable 
  },
  data () {
    return {
      filterForm: {
        orderCode: '',
        receiptCode: '',
        createdAtFrom: null,
        createdAtTo: null,
        paymentAtFrom: null,
        paymentAtTo: null,
      },
      transactions: [],
      currentPage: 1,
      limit: 10,
      totalItem: 0,
      loading: false,
      backward: false,
      paging: {},
      idPaging: null,
    }
  },
  watch: {
    currentPage: {
      handler (newVal, oldVal) {
        this.backward = newVal === 1 ? false : newVal < oldVal
        this.getQrTransactionList()
      },
    },
    limit: {
      handler () {
        if (this.currentPage === 1) {
          this.getQrTransactionList()
        } else {
          this.currentPage = 1
        }
      },
    },
  },
  async created () {
    this.getQrTransactionList()
    Bus.$on('qr-transaction-list-filter', (filterForm) => {
      this.filterForm = filterForm
      this.currentPage = 1
      this.backward = false
      this.idPaging = null
      this.getQrTransactionList()
    })
    Bus.$on('qr-transaction-reload', () => {
      this.getQrTransactionList()
    })
  },
  beforeDestroy () {
    Bus.$off('qr-transaction-list-filter')
    Bus.$off('qr-transaction-reload')
  },
  methods: {
    showTransactionsIndex() {
      if (this.transactions.length > 0) {
        const maxIndex = parseInt(this.currentPage) * parseInt(this.limit)
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
      } else {
        return '0 - 0'
      }
    },
    async getQrTransactionList () {
      this.loading = true
      const params = {
        limit: this.limit,
        page: this.currentPage,
        orderCode: this.filterForm.orderCode ? this.filterForm.orderCode.trim() : null,
        receiptCode: this.filterForm.receiptCode ? this.filterForm.receiptCode.trim() : null,
        createdAtFrom: this.filterForm.createdAtFrom,
        createdAtTo: this.filterForm.createdAtTo,
        paymentAtFrom: this.filterForm.paymentAtFrom,
        paymentAtTo: this.filterForm.paymentAtTo,
        backward: this.backward,
        id: this.idPaging || '',
      }
      
      const loader = this.$loading.show()
      try {
        const response = await PaymentQRCodeRepository.listTransactions(params)
        loader.hide()
        this.loading = false
        
        if (response && response.data && response.data.data) {
          const responseData = response.data.data
          const transactionsData = responseData.data || []
          const paging = responseData.paging || {}
          
          // Lưu paging để sử dụng cho phân trang
          this.paging = paging
          
          // Tính totalItem: nếu có nextId thì có thể còn trang tiếp theo
          // Ước tính totalItem dựa trên số items hiện tại và paging
          if (transactionsData.length === this.limit && paging.nextId) {
            // Có đủ items và còn trang tiếp theo, ước tính totalItem
            this.totalItem = this.currentPage * this.limit + 1
          } else {
            // Trang cuối hoặc không có nextId
            this.totalItem = (this.currentPage - 1) * this.limit + transactionsData.length
          }
          
          // Thêm STT cho mỗi transaction dựa trên phân trang
          const startIndex = (this.currentPage - 1) * this.limit
          this.transactions = transactionsData.map((item, index) => ({
            ...item,
            stt: startIndex + index + 1
          }))
        } else {
          this.transactions = []
          this.totalItem = 0
          this.paging = {}
        }
      } catch (error) {
        console.error('Error fetching QR transactions:', error)
        loader.hide()
        this.loading = false
        this.transactions = []
        this.totalItem = 0
        this.paging = {}
      }
    },
    exportExcel() {
      const params = {
        limit: 300, // BE request limit is 300
        orderCode: this.filterForm.orderCode ? this.filterForm.orderCode.trim() : null,
        receiptCode: this.filterForm.receiptCode ? this.filterForm.receiptCode.trim() : null,
        createdAtFrom: this.filterForm.createdAtFrom,
        createdAtTo: this.filterForm.createdAtTo,
        paymentAtFrom: this.filterForm.paymentAtFrom,
        paymentAtTo: this.filterForm.paymentAtTo,
      }
      PaymentQRCodeRepository.exportTransactions(params).then(response => {
        if (response && response.data && response.data.data) {
          const responseData = response.data.data.data
          this.$store.commit('ADD_APP_NOTIFICATION', {
            type: 'info_excel',
            title: 'Xuất file Excel',
            message: responseData.message,
          });
        }
      }).catch(error => {
        console.error('Error exporting QR transactions:', error)
      })
    },
  },
}
</script>

<style scoped>
#qr-transaction-list {
  padding: 0px 15px;
}
.qr-transaction__wrapper {
  padding-bottom: 0px !important;
  margin-bottom: 10px !important;
}

.pagination-btn-left, .pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}
.pagination-btn-left i, .pagination-btn-right i {
  color: rgba(0,0,0,.54) !important
}
.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}
.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}
</style>
